import type { Guide, GuideRecordHint } from '../types';

/**
 * S-24.10-06 — zlecenie w realizacji w TMS nie jest wariantem (scenariusz e2e 27; decyzja użytkownika 21.10.2026,
 * C33). Rekord: DEMO 027 z kandydaturą do DEMO/2026/10/G02, które TMS ma w realizacji (C), bez naszego pojazdu;
 * dane: `e2e/setup/seed-e2e.ts`, `gantt2410`.
 */
const CAR: GuideRecordHint = {
  description: 'pojazd z kandydaturą do zlecenia, które TMS ma już w realizacji',
  listPath: '/cars',
};

export const guide: Guide = {
  flagKey: 'runningOrderNotVariant',
  title: 'Zlecenie w realizacji w TMS nie jest wariantem',
  whatItDoes:
    'Gdy zlecenie, do którego pojazd kandydował, TMS ma już w realizacji albo zrealizowane, to wskazanie przestaje być wariantem: nie stoi w wierszu „Warianty” na osi karty pojazdu, tylko w linii stanu z TMS, nie liczy się do liczby wariantów w nagłówku harmonogramu ani do znacznika i filtra „z wariantem” w harmonogramie floty. W tabeli pod osią ma podpis „zlecenie w realizacji w TMS — nie jest wariantem”. Kandydatury nic samo nie zwalnia.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-24.10-06'],
  steps: [
    {
      route: '/cars/:carId/show',
      record: CAR,
      target: 'gantt-track-inProgress',
      title: 'Kandydatura w linii „W trakcie”, nie w „Warianty”',
      description:
        'Pasek zlecenia, które TMS ma w realizacji, stoi w linii „W trakcie” z dopiskiem „kandydatura”, a wiersz „Warianty” go nie pokazuje. Dymek paska mówi, że to nie wariant i że kandydatury nie zwalniamy automatycznie.',
      action: 'Na karcie pojazdu w „Harmonogramie” najedź na pasek z dopiskiem „kandydatura”.',
      recorder: { account: 'master', demo: { kind: 'car', plate: 'DEMO 027' } },
    },
    {
      route: '/cars/:carId/show',
      record: CAR,
      target: 'plan-state-not-variant',
      title: 'Podpis w tabeli pod osią',
      description:
        'W kolumnie „Stan” pozycja ma podpis „zlecenie w realizacji w TMS — nie jest wariantem”. Nagłówek harmonogramu liczy tylko prawdziwe warianty.',
      action: 'Przewiń do tabeli pod osią i znajdź pozycję z tym podpisem.',
      recorder: { account: 'master', demo: { kind: 'car', plate: 'DEMO 027' } },
    },
    {
      route: '/fleet-schedule',
      target: 'fleet-counter-variant',
      title: 'Harmonogram floty: „Z wariantem” bez takich pozycji',
      description:
        'Licznik „Z wariantem” nad osią i filtr „Pokaż: z wariantem” w harmonogramie floty nie liczą kandydatur do zleceń, które TMS ma już w realizacji — pojazd z samą taką kandydaturą nie trafia do listy „z wariantem”.',
      action: 'W harmonogramie floty spójrz na licznik „Z wariantem” i wybierz „Pokaż: z wariantem”.',
      recorder: { account: 'master' },
    },
  ],
};
